import React, { useState, useEffect, Children } from 'react';
import { Box, IconButton } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const navButtonSx = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: '#337AB7',
    color: 'white',
    '&:hover': { backgroundColor: '#286090' },
};

const dotSx = (active) => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    margin: '0 4px',
    cursor: 'pointer',
    backgroundColor: active ? '#337AB7' : '#a9c6e0',
    display: 'inline-block',
});

const ImageCarousel = ({ show, numOfImages, children, onChange }) => {
    const items = Children.toArray(children);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (index >= items.length && items.length > 0) {
            setIndex(0);
        }
    }, [items.length, index]);

    if (!show) {
        return (
            <Box sx={{ padding: '2% 0' }}>
                <p>No images to show</p>
            </Box>
        );
    }

    const total = numOfImages ?? items.length;
    const go = (next) => {
        const len = items.length || 1;
        const n = ((next % len) + len) % len;
        setIndex(n);
        if (onChange) onChange(n, items[n]);
    };

    return (
        <>
            <p style={{ textAlign: 'center' }}>{index + 1} of {total}</p>
            <Box sx={{ position: 'relative', padding: '2% 0', minHeight: 200 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {items[index]}
                </Box>
                {items.length > 1 && (
                    <>
                        <IconButton
                            aria-label="previous"
                            onClick={() => go(index - 1)}
                            sx={{ ...navButtonSx, left: 8 }}
                        >
                            <NavigateBeforeIcon />
                        </IconButton>
                        <IconButton
                            aria-label="next"
                            onClick={() => go(index + 1)}
                            sx={{ ...navButtonSx, right: 8 }}
                        >
                            <NavigateNextIcon />
                        </IconButton>
                        <Box sx={{ textAlign: 'center', mt: 1 }}>
                            {items.map((_, i) => (
                                <Box key={i} component="span" sx={dotSx(i === index)} onClick={() => go(i)} />
                            ))}
                        </Box>
                    </>
                )}
            </Box>
        </>
    );
};

export default ImageCarousel;
